import { render } from "./Arrange.vue?vue&type=template&id=ca7fbe80&scoped=true"
import script from "./Arrange.vue?vue&type=script&lang=js"
export * from "./Arrange.vue?vue&type=script&lang=js"

import "./Arrange.vue?vue&type=style&index=0&id=ca7fbe80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7fbe80"],['__file',"src/components/properties/Arrange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca7fbe80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca7fbe80', __exports__)) {
    api.reload('ca7fbe80', __exports__)
  }
  
  module.hot.accept("./Arrange.vue?vue&type=template&id=ca7fbe80&scoped=true", () => {
    api.rerender('ca7fbe80', render)
  })

}


export default __exports__